import { LayoutWithNavigationBar } from "../../../layouts/layout-with-navigation-bar";
import { MainView } from "../../../views/inbound/pallet-info-v2";

export default function Inbound_PaletteInfo(props) {
    return (
        <>
            <LayoutWithNavigationBar>
                <MainView />
            </LayoutWithNavigationBar>
        </>
    );
}